import React from "react";
import PreregisterAreaConfirm from "./PreregisterAreaConfirm";

function PreregisterConfirm(props) {
    const { item_id } = props.match.params;
  return (
    <>
      <PreregisterAreaConfirm item_id={item_id}  />
    </>
  );
}

export default PreregisterConfirm;
